/* ATTENDEES */
import GenerateAccessCodesJob from './generate-access-codes';
import UploadAccessCodesJob from './access-codes-upload';
import DeleteAttendeeJob from './delete-attendee';
import AttendeesUploadJob from './attendees-upload';
import AttendeesUpdateBulk from './attendees-update-bulk';
/* ROOMS */
import AssignMeetingsToRoomsJob from './assign-meetings-to-rooms';
import GenerateRoomConnectionsJob from './generate-room-connections';
import GenerateRoomsJob from './generate-rooms';
import OperatorsUploadJob from './operators-upload';
/* MEETINGS */
import MeetingsCancelJob from './meetings-cancel';
import MeetingsRemoveJob from './meetings-remove';
import MeetingsUploadJob from './meetings-upload';
import MeetingConnectionsBulkUpdate from './meeting-connections-update-bulk';
/* ORGANIZATIONS */
import OrganizationsUploadJob from './organizations-upload';
import GenerateOrganizationLinksJob from './generate-organizations-links';
import DeleteOrganizationJob from './delete-organization';
/* PASSPORT */
import PassportConfigurationUploadJob from './passport-configuration-upload';
/* BLUEPRINTS */
import EventBlueprintTriggerJob from './event-blueprint-trigger';
import MeetingBlueprintTriggerJob from './meeting-blueprint-trigger';
import GenerateConnectionsBlueprintTriggerJob from './generate-connections-blueprint-trigger';
/* ORGANIZATIONS */
import DeleteUniqueJoiningLinksJob from './delete-unique-joining-links';


export default {
    ...GenerateAccessCodesJob,
    ...UploadAccessCodesJob,
    ...DeleteAttendeeJob,
    ...AssignMeetingsToRoomsJob,
    ...GenerateRoomConnectionsJob,
    ...GenerateRoomsJob,
    ...MeetingsCancelJob,
    ...MeetingsRemoveJob,
    ...MeetingsUploadJob,
    ...OperatorsUploadJob,
    ...OrganizationsUploadJob,
    ...GenerateOrganizationLinksJob,
    ...AttendeesUploadJob,
    ...DeleteOrganizationJob,
    ...AttendeesUpdateBulk,
    ...MeetingConnectionsBulkUpdate,
    ...PassportConfigurationUploadJob,
    ...EventBlueprintTriggerJob,
    ...MeetingBlueprintTriggerJob,
    ...GenerateConnectionsBlueprintTriggerJob,
    ...DeleteUniqueJoiningLinksJob,
};
